/**
 * @architecture-header 1
 * @layer shared
 * @domain internationalisation
 * @responsibility Translate interface strings for the active workspace language.
 * @state-owner navigation store owns the selected language
 * @allowed-imports i18n dictionary constant
 * @forbidden network; React; component markup
 * @public-api workspace shell and modules
 * @side-effects none
 * @tests workspace-behaviour.test.ts
 */

import { TRANSLATIONS } from './i18n-dictionary';

export type WorkspaceLanguage = 'zh' | 'en';

export function translate(language: WorkspaceLanguage, source: string): string {
  if (language !== 'en') return source;
  const value = TRANSLATIONS[source];
  return value !== undefined && value !== '' ? value : source;
}

export type Translator = (source: string) => string;

export function createTranslator(language: WorkspaceLanguage): Translator {
  return (source: string) => translate(language, source);
}
